import { Box, IconButton, Modal, Typography } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

type Props = {
  preview: { src: string; title?: string } | null;
  onClose: () => void;
};

const MessagesImageModal = ({ preview, onClose }: Props) => {
  return (
    <Modal
      open={Boolean(preview)}
      onClose={onClose}
      aria-labelledby="messages-image-title"
      BackdropProps={{ className: "messages-image-backdrop" }}
    >
      <Box className="messages-image-modal" onClick={onClose}>
        <Box
          className="messages-image-modal-header"
          onClick={(event) => event.stopPropagation()}
        >
          <Typography id="messages-image-title" className="messages-image-title">
            {preview?.title || "Image preview"}
          </Typography>
          <IconButton
            className="messages-image-close"
            aria-label="Close image preview"
            onClick={onClose}
          >
            <CloseIcon />
          </IconButton>
        </Box>
        <Box
          className="messages-image-modal-body"
          onClick={(event) => event.stopPropagation()}
        >
          {preview?.src && (
            <img
              src={preview.src}
              alt={preview?.title || "Image preview"}
              className="messages-image-modal-image"
            />
          )}
        </Box>
      </Box>
    </Modal>
  );
};

export default MessagesImageModal;
